// 흐린 배경 채우기(9/28 사장님 「1번으로 넣어봐」 — 태블릿·데스크톱에서 가운데 세로 영상 양옆이 검게 비던 것).
// 지금 보이는 영상(#stage 안의 video.on)의 한 장면을 작은 캔버스에 옮겨 그리고, 화면 가득 크게 흐리고 어둡게 편다.
// 영상을 한 번 더 틀지 않는다(한 장면씩 옮겨 그릴 뿐이라 가볍다). 폰(좁은 화면)은 영상이 꽉 차므로 돌지 않는다.
// 무비(play.html)와 타로(tarot.html)가 같이 쓴다 — 두 화면 모두 #stage 가 폭 430px 로 가운데 있다.
(() => {
  const wide = matchMedia("(min-width: 520px)");
  const style = document.createElement("style");
  style.textContent = `
#amb{position:fixed;left:-10%;top:-10%;width:120%;height:120%;z-index:0;pointer-events:none;
  filter:blur(38px) brightness(.72) saturate(1.25);opacity:0;transition:opacity 1s ease}
#amb.on{opacity:1}
@media (max-width:519px){#amb{display:none}}
@media (min-width:520px){#stage{z-index:1;box-shadow:0 0 90px 36px rgba(0,0,0,.5)}}
@media (prefers-reduced-motion:reduce){#amb{transition:none}}`;
  document.head.appendChild(style);

  const cv = document.createElement("canvas");
  cv.id = "amb";
  cv.setAttribute("aria-hidden", "true");
  document.body.prepend(cv);
  const ctx = cv.getContext("2d", { alpha: false });
  const fit = () => { cv.width = 64; cv.height = Math.max(24, Math.round((64 * innerHeight) / Math.max(1, innerWidth))); };
  fit();
  addEventListener("resize", fit);

  let img = null, imgSrc = "", last = 0;
  // 지금 보이는 것 — 켜진 영상(겹쳐 바뀌는 중이면 뒤에 온 것). 영상이 없으면 첫 화면 그림(#gate 배경).
  function source() {
    const on = [...document.querySelectorAll("#stage video.on")].filter((v) => v.readyState >= 2 && v.videoWidth);
    if (on.length) return on[on.length - 1];
    const gate = document.getElementById("gate");
    const m = gate && getComputedStyle(gate).backgroundImage.match(/url\("?(.*?)"?\)/);
    if (!m) return null;
    if (imgSrc !== m[1]) { imgSrc = m[1]; img = new Image(); img.src = imgSrc; }
    return img.complete && img.naturalWidth ? img : null;
  }
  // 세로 장면의 가운데 띠를 화면 비율로 잘라(cover) 옮겨 그린다
  function paint(s) {
    const sw = s.videoWidth || s.naturalWidth, sh = s.videoHeight || s.naturalHeight;
    if (!sw || !sh) return false;
    const want = cv.width / cv.height, have = sw / sh;
    let cw = sw, ch = sh;
    if (have > want) cw = sh * want; else ch = sw / want;
    ctx.drawImage(s, (sw - cw) / 2, (sh - ch) / 2, cw, ch, 0, 0, cv.width, cv.height);
    return true;
  }
  function tick(t) {
    requestAnimationFrame(tick);
    if (!wide.matches || document.hidden || t - last < 120) return;   // 넓은 화면에서만, 1초에 여덟 번쯤
    last = t;
    const s = source();
    if (!s) return;
    try { if (paint(s)) cv.classList.add("on"); } catch { /* 아직 그릴 수 없는 장면 — 다음 번에 */ }
  }
  requestAnimationFrame(tick);
})();
